import type React from "react"

interface HomeHeroShellProps {
  children: React.ReactNode
}

export function HomeHeroShell({ children }: HomeHeroShellProps) {
  return (
    <section
      id="upload-section"
      className="relative bg-linear-to-b from-green-50 to-white px-4 pt-12 pb-16 md:pt-[72px] md:pb-24 scroll-mt-20 overflow-hidden flex flex-col items-center justify-center min-h-[calc(100svh-4rem)] md:min-h-[calc(100svh-5rem)]"
    >
      <div className="max-w-3xl w-full mx-auto relative z-10">{children}</div>
    </section>
  )
}
